import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/EngineGlassmorphism.css';

const API_URL = import.meta.env?.VITE_API_URL || 'https://tube.contentserp.in/api/engine';

export default function AdminObservability({ user }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await axios.get(`${API_URL}/admin/stats`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setStats(res.data.stats);
      } catch (e) {
        console.error('Failed to load stats', e);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
    
    const timer = setInterval(fetchStats, 10000);
    return () => clearInterval(timer);
  }, []);

  if (loading) {
    return <div className="engine-dashboard"><div className="engine-glass-panel">Loading Observability Data...</div></div>;
  }

  return (
    <div className="engine-dashboard">
      <header className="engine-header">
        <h1>🛡️ Observability & Health</h1>
        <p>Real-time AI Recommendation Engine Metrics</p>
      </header>

      <div className="engine-scores-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
        <div className="engine-glass-panel score-card">
          <h3>Total AI Jobs</h3>
          <div className="score-value">{stats?.totalJobs || 0}</div>
        </div>
        <div className="engine-glass-panel score-card">
          <h3>Avg Latency</h3>
          <div className="score-value">{stats?.avgLatency ? `${stats.avgLatency}ms` : '0ms'}</div>
        </div>
        <div className="engine-glass-panel score-card">
          <h3>Avg Cost</h3>
          <div className="score-value" style={{color: '#ec4899'}}>
            ${stats?.avgCost ? stats.avgCost.toFixed(4) : '0.00'}
          </div>
        </div>
      </div>

      <div className="engine-glass-panel">
        <span className="ai-badge" style={{background: 'rgba(239,68,68,0.2)', color: '#fca5a5'}}>Circuit Breaker Status</span>
        <ul className="ai-recommendation-list">
          {stats?.circuitBreakers?.map((cb, idx) => (
             <li key={idx} style={{borderLeftColor: cb.status === 'CLOSED' ? '#10b981' : '#ef4444'}}>
               <strong>{cb.provider}</strong>: {cb.status}
             </li>
          ))}
          {(!stats?.circuitBreakers || stats.circuitBreakers.length === 0) && (
            <li>No circuit breaker data available.</li>
          )}
        </ul>
      </div>
    </div>
  );
}
